import {
  REACT_APP_AWS_REGION,
  REACT_APP_AWS_USER_POOL,
  REACT_APP_AWS_POOL_WEB_CLIENTID,
  REACT_APP_AWS_COGNITO_DOMAIN,
  REACT_APP_AWS_COGNITO_REDIRECTSIGNIN,
  REACT_APP_AWS_COGNITO_REDIRECTSIGNOUT } from '../helpers/variableHelper';
const awsmobile =  {
   // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
   //identityPoolId: 'XX-XXXX-X:XXXXXXXX-XXXX-1234-abcd-1234567890ab',
   // REQUIRED - Amazon Cognito Region
   region: REACT_APP_AWS_REGION,
   // OPTIONAL - Amazon Cognito Federated Identity Pool Region 
   // Required only if it's different from Amazon Cognito Region
   //identityPoolRegion: 'XX-XXXX-X',
   // OPTIONAL - Amazon Cognito User Pool ID
   userPoolId: REACT_APP_AWS_USER_POOL,
   // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
   userPoolWebClientId: REACT_APP_AWS_POOL_WEB_CLIENTID,
   // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
   mandatorySignIn: true,
   // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
   //authenticationFlowType: 'USER_PASSWORD_AUTH',
   // OPTIONAL - Manually set key value pairs that can be passed to Cognito Lambda Triggers
    // OPTIONAL - Hosted UI configuration
    oauth: {
        domain: REACT_APP_AWS_COGNITO_DOMAIN,
        scope: [
          "email",
          "openid",
          "profile",
          "aws.cognito.signin.user.admin"
        ],
        redirectSignIn: REACT_APP_AWS_COGNITO_REDIRECTSIGNIN,
        redirectSignOut: REACT_APP_AWS_COGNITO_REDIRECTSIGNOUT,
        responseType: "code"
      }
}


export default awsmobile;